import { ErrorElement } from './error'

export function NotFound() {
  return <ErrorElement content='抱歉！您访问的页面不存在' />
}
